/** @format */
import React from 'react'
import { _$, Card } from 'kpc-react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
// eslint-disable-next-line max-len
import CloudListTableCopyTips from 'src/containers/MonitorCloud/CloudListTable/CloudListTableCopyTips'
import { getRulesUnits } from 'src/containers/MonitorHistoryTactics/constants'
import { CollapseItemProps } from './constants'
const AlarmingCollapseItem: React.FC<CollapseItemProps> = ({
  resources,
  regionList,
  productType
}) => {
  const history = useHistory()

  return (
    <div className="alram-box">
      {resources?.length
        ? resources.map(({ instanceName, instanceId, records, region }) => {
            const reginName = regionList.find(({ regionKey }) => regionKey === region)?.regionName
            return (
              <Card
                key={instanceId}
                b-title={
                  <div className="instance-title">
                    <div className="instance-box">
                      <p className="instance-name">{instanceName}</p>
                      <CloudListTableCopyTips instanceId={instanceId} />
                    </div>
                    <p className="region">{reginName || region}</p>
                  </div>
                }
                className="alram-item"
              >
                {records?.length
                  ? records.map(({ policyId, policyRule, curValue, duration, triggerTime }) => {
                      const { units, triggerValue } = getRulesUnits(
                        policyRule,
                        curValue,
                        productType
                      )
                      return (
                        <p
                          className="text"
                          key={policyId}
                          onClick={() => {
                            // history.push(`/monitor/alarmServer/tactics/edit/${policyId}`)
                            history.push(`/monitor/alarmServer/rule/detail/${policyId}`)
                          }}
                        >
                          <span>
                            {_$('告警规则')}：
                            {policyRule
                              .replace(/LessThanLastPeriod/g, _$('周期环比下降'))
                              .replace(/GreaterThanLastPeriod/g, _$('周期环比上涨'))}
                          </span>
                          <span>
                            {_$('触发值')}：{triggerValue}
                            {units}
                          </span>
                          <span>
                            {_$('发生时间')}：{triggerTime}
                          </span>
                          <span>
                            {_$('持续时间')}：{duration}
                          </span>
                        </p>
                      )
                    })
                  : null}
              </Card>
            )
          })
        : null}
    </div>
  )
}
export default styled(AlarmingCollapseItem)``
